import React from 'react';
import PropTypes from 'prop-types';
import { SHOP_LOCATOR } from '../../../routes/externalLinks';
import Button from '../../../components/common/Button';

const CardCanceled = ({ returnToHome = () => {}, close = () => {} }) => {
  const goToHome = () => {
    close();
    returnToHome();
  };
  const goToShopLocator = () => {
    close();
    window.location.assign(SHOP_LOCATOR);
  };
  return (
    <div className="modal">
      <div className="modal__icon">
        <i className="modal__icon--check material-icon material-icon--check" />
      </div>
      <h2 className="modal__header">Card Canceled</h2>
      <p className="modal__paragraph">
        Pick up another card from any William Hill store and a member of staff will help you
        register
        it straight away.
      </p>
      <Button className="modal__button" onClick={goToHome}>Return to Home</Button>
      <Button className="modal__button modal__button--top-margin" onClick={goToShopLocator}>
        Shop Locator
      </Button>
    </div>
  );
};

CardCanceled.propTypes = {
  returnToHome: PropTypes.func,
  close: PropTypes.func
};

export default CardCanceled;
